import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';

const PermissionMatrix = ({ permissions, onPermissionChange, loading }) => {
  const featureCategories = [
    'Dashboard Views',
    'Transaction Management',
    'Merchant Operations',
    'Financial Reports',
    'System Administration',
    'User Management'
  ];

  const permissionTypes = [
    { key: 'canView', label: 'View' },
    { key: 'canEdit', label: 'Edit' },
    { key: 'canCreate', label: 'Create' },
    { key: 'canDelete', label: 'Delete' },
    { key: 'canExport', label: 'Export' }
  ];

  const getPermissionForCategory = (role, category) => {
    return permissions?.find(p => p?.role === role && p?.featureCategory === category);
  };

  const handlePermissionToggle = (permissionId, permissionType, currentValue) => {
    onPermissionChange(permissionId, { [permissionType]: !currentValue });
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-border p-8">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <span className="ml-3 text-muted-foreground">Loading permissions...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider sticky left-0 bg-muted/50">
                Feature Category
              </th>
              {permissionTypes?.map((type) => (
                <th key={type?.key} className="px-6 py-3 text-center text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  {type?.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {featureCategories?.map((category) => {
              const permission = getPermissionForCategory('admin', category);
              return (
                <tr key={category} className="hover:bg-muted/30 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-foreground sticky left-0 bg-white">
                    {category}
                  </td>
                  {permissionTypes?.map((type) => (
                    <td key={type?.key} className="px-6 py-4 text-center">
                      <Checkbox
                        checked={permission?.[type?.key] || false}
                        onChange={() => handlePermissionToggle(permission?.id, type?.key, permission?.[type?.key])}
                        className="justify-center"
                      />
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PermissionMatrix;